import { Injectable } from '@angular/core';
import { CreditCardPaymentService } from 'src/app/public-website/buyer/services/creditCardPayment.service';
import { SubmitBuyerInfoService } from 'src/app/public-website/buyer/services/submit-buyer-info.service';
import { GlobalLoaderService } from 'src/app/shared/services/global-loader.service';
import { AppleMerchantValidation } from './apple-merchant-validation.service';
import { AppleVipsCalculatorService } from './apple-vips-calculator.service';
import { applePaymentConfig } from '../helper/ApplePaymentConfig';
import { Subject } from 'rxjs';



@Injectable()
export class ApplePayService {
  public paymentStatus$: Subject<ApplePayStatus> = new Subject<ApplePayStatus>();

  constructor(
    private appleMerchantValidation: AppleMerchantValidation,
    private creditCardService: CreditCardPaymentService,
    private submitBuyerInfo: SubmitBuyerInfoService,
    private appleVipsCalculatorService: AppleVipsCalculatorService,
    private globalLoaderService: GlobalLoaderService,
  ) {}

  async isAvailable() {
    return await this.appleVipsCalculatorService.checkAppleCapabilities();
  }

  private onValidateMerchant(session: any, submitBuyerDataFunction: Function) {
    return async (event) => {
      console.log('Validate merchant,');
      let validationResponse = {};
      try {
        await submitBuyerDataFunction();
        const response = this.submitBuyerInfo.data;
        if (!response) throw new Error('No data available to process..');
        this.appleMerchantValidation.deactivateLoader();
        this.appleMerchantValidation.setParams({
          validationURL: event.validationURL,
          trxId: response.PaymentAttempt.id,
          trxRefNum: this.creditCardService.trxRefNum,
        });
        validationResponse = await this.appleMerchantValidation.make();
        if (!validationResponse)
          throw new Error('Empty Merchant validation Response');
        session.completeMerchantValidation(validationResponse);
      } catch (e) {
        console.log('Something went wrong with Merchant validation,', e);
      } finally {

      }
    };
  }

  onPaymentAuthorized(session: any){
    return  async (event) => {
      console.log('Payment Authorization');
      const token = event.payment.token;
      let trx = this.creditCardService.trxRefNum;
      let isPaid = false;
      if (!token.paymentData) return session.completePayment(1);
      const tokenString = JSON.stringify(token.paymentData);
      try {
        this.creditCardService.deactivateLoader()
        this.creditCardService.setPayToken({paymentToken: tokenString, trxRef: trx});

        const creditCardService = await this.creditCardService.make();
        if(creditCardService?.message !== "APPROVED") throw new Error(creditCardService?.message ?? "Something wrong happened");
        isPaid = true;
        session.completePayment(window["ApplePaySession"].STATUS_SUCCESS);
      } catch (e) {
        console.log('Payment Authorization Failed, ', e);
        session.completePayment(window["ApplePaySession"].STATUS_FAILURE ?? 1);
      } finally {
        this.paymentStatus$.next({isPaid, trxRefNum: trx, status: "COMPLETED"});
      }
    };
  }

  pay(submitBuyerDataFunction: Function) {
    try {
      const vips = this.appleVipsCalculatorService.getSubmitObject();
      this.globalLoaderService.disable();
      console.log("Init apple request with: ", applePaymentConfig.getRequest(vips));

      //@ts-ignore
      var session = new window.ApplePaySession(
        applePaymentConfig.appleJsVersion,
        applePaymentConfig.getRequest(vips)
      );

      session.onvalidatemerchant = this.onValidateMerchant(
        session,
        submitBuyerDataFunction
      );
      session.onpaymentauthorized = this.onPaymentAuthorized(session);

      session.oncancel = () => {
        console.log('oncancel');
        this.globalLoaderService.enable();
      };

      session.abort = () => {
        console.log('abort');
        this.globalLoaderService.enable();
      };

      session.begin();
      return this.paymentStatus$;
    } catch (e) {
      console.log('onApplePayButtonClicked: error ', e);
      this.globalLoaderService.enable();
      return null;
    }
  }
}



type ApplePayStatus = {isPaid: boolean, trxRefNum: string, status: string | null};
